/**
 * Returns the current Sydney timezone abbreviation (AEST or AEDT)
 * based on whether daylight saving time is active.
 */
export const getSydneyTimezoneLabel = (): string => {
  const formatter = new Intl.DateTimeFormat('en-AU', {
    timeZone: 'Australia/Sydney',
    timeZoneName: 'short',
  });

  const parts = formatter.formatToParts(new Date());
  const tzPart = parts.find((p) => p.type === 'timeZoneName');

  return tzPart?.value ?? 'AEST';
};
